import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sm-toolbar',
    templateUrl: './sm-toolbar.component.html',
    styleUrls: ['./sm-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmToolbarComponent {

    @Input()
    center = false;
    @Input()
    spaceBetween = false;
    @Input()
    noBorder = false;
}
